export default "__VITE_ASSET__859f8589__"